const FULL_NAME = {
  label: 'Full Name',
  icon: 'small-user-single',
  value: 'FULL_NAME',
};

const EMAIL = {
  label: 'Email',
  icon: 'small-mail-send-envelope',
  value: 'EMAIL',
};

const EIN = {
  label: 'EIN',
  icon: 'small-mail-sign-hashtag',
  value: 'EIN',
};

const SSN = {
  label: 'SSN',
  icon: 'small-mail-sign-hashtag',
  value: 'SSN',
};

const BUSINESS_ADDRESS = {
  label: 'Business Address',
  icon: 'small-location-pin',
  value: 'BUSINESS_ADDRESS',
};

const PERSONAL_ADDRESS = {
  label: 'Personal Address',
  icon: 'small-location-pin',
  value: 'PERSONAL_ADDRESS',
};

export const TYPE_MAP = {
  FULL_NAME: FULL_NAME,
  EMAIL: EMAIL,
  EIN: EIN,
  SSN: SSN,
  BUSINESS_ADDRESS: BUSINESS_ADDRESS,
  PERSONAL_ADDRESS: PERSONAL_ADDRESS,
};
